import React from "react";
import Explore from "./content/Explore";
import SoMe from "./content/SoMe";

export default function Contact() {
  return (
    <div id="contact" className="contact">
      <div className="contact__content">
        <SoMe />
        <Explore />
      </div>
      <div className="contact__copy">
        <p>Designed & Developed by Alexandra Pettersen</p>
      </div>
    </div>
  );
}
